export const thresholds = {
    mobile: 1024
}